export default "__VITE_PUBLIC_ASSET__a6b0a178__"